<template>
  <NavigationButtonIcon
    :url="routeLink.path"
    :label="category.title"
    icon-name="nomad:diamond"
    @click.capture="handleClickPath"
  />
</template>
<script setup lang="ts">
interface Props {
  category: CategorySchema;
}
const props = defineProps({
  category: null
});
const { handleClickPath, routeLink } = await useCategoryLinkTryAndLock(
  props.category
);
</script>
